import { UrgencyIdField, MultiSelectIdField, PrecautionFields } from '~fields';
import RoomFields from './RoomFields';

const OtherCleanupFields = props => (
  <>
    <MultiSelectIdField
      name="otherCleanupType"
      maxCharacterCount={40}
      required
    />

    <RoomFields {...props} />

    <UrgencyIdField name="urgency" required />

    <PrecautionFields {...props} />
  </>
);

export default OtherCleanupFields;
